var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 18,
    viewBox: "0 0 89 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5901 18C37.6031 18 41.667 13.975 41.667 9.01006C41.667 4.04506 37.6031 0.0201416 32.5901 0.0201416C27.5771 0.0201416 23.5132 4.04506 23.5132 9.01006C23.5132 13.975 27.5771 18 32.5901 18Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0919 8.28115C17.7159 3.65905 13.8253 0.0201416 9.06303 0.0201416C4.06156 0.0201416 0 4.04893 0 9.01006C0 13.9712 4.06156 18 9.06303 18C14.0645 18 17.7159 14.3611 18.0919 9.73897H9.37634V8.27549H18.0919V8.28115Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6304 17.9798C84.6264 17.9798 88.6764 13.9549 88.6764 8.98991C88.6764 4.02492 84.6264 0 79.6304 0C74.6345 0 70.5845 4.02492 70.5845 8.98991C70.5845 13.9549 74.6345 17.9798 79.6304 17.9798Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9351 4.48083C62.3658 1.8025 59.4547 0 56.1172 0C51.1195 0 47.0713 4.02879 47.0713 8.98991C47.0713 13.951 51.1252 17.9798 56.1172 17.9798C61.1093 17.9798 65.1632 13.951 65.1632 8.98991H56.1229L63.9351 4.47518V4.48083Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.edd6517c76e8ed27511c63449d8a8e69.svg";
export { ForwardRef as ReactComponent };